const fetchAs = require("./fetchAs");

/**
 * Fetch all entities of given bundle
 *
 * @param endpoint: '/type/bundle'
 * @param dispatch: a function from to make authenticated requests (optional)
 * @param headers: headers to use in anonymous fetch (optional)
 * @param agent: agent to use in anonymous fetch (optional)
 */

module.exports = async function fetchEntities({
	endpoint,
	dispatch = null,
	headers = null,
	agent = null,
	limit = 0,
	pagination = null,
}) {
	let page = null;

	const getNext = async (url, data = [], first) => {
		if (typeof url === "object") {
			url = url.href;
		}
		let _endpoint = url.split("jsonapi/")[1];
		let response = await fetchAs({ endpoint: _endpoint, dispatch, headers, agent });

		if (
			pagination &&
			first &&
			limit &&
			response &&
			response.meta &&
			response.meta.count
		) {
			page = {
				size: limit,
				current: 1,
				total_results: parseInt(response.meta.count),
				total_pages: Math.ceil(parseInt(response.meta.count) / limit),
			};
		}
		if (response && !!response.data) {
			if (response.included) {
				attachRelToAttributes(response);
			}

			data = Array.isArray(response.data) ? data.concat(response.data) : data;
			if (response.links && response.links.next) {
				if (limit === 0) {
					data = await getNext(response.links.next, data);
				}
			}
		} else {
			return [];
		}
		return data;
	};

	const data = await getNext(
		`${process.env.CLF_BACKEND_URL}/jsonapi/${endpoint}`,
		[],
		true
	);

	return {
		data,
		page,
	};
};

function attachRelToAttributes(response) {
	response.data.forEach((item, index, self) => {
		let { relationships } = item;
		Object.keys(relationships).forEach((key) => {
			if (Array.isArray(item.relationships[key].data)) {
				let values = [];

				item.relationships[key].data.forEach((rel, relIndex) => {
					let relFound = response.included.find((inc) => inc.id == rel.id);
					if (relFound) {
						if (
							self[index].relationships[key].data[relIndex].type.indexOf(
								"taxonomy_term"
							) > -1
						) {
							values = [...values, relFound.attributes.name];
						} else if (
							self[index].relationships[key].data[relIndex].type.indexOf("node") > -1
						) {
							values = [...values, relFound.attributes.title];
						}
					}
				});

				self[index].attributes[key] = values;
			}
		});
	});
}
